module.exports = __webpack_public_path__ + "static/media/lastIconGrey.48dc7fed.svg";